import GeneralTranslations from "../../../Common/ModuleTranslations/fr";

export default {
  locale: "fr",
  name: "Politiques de modification",
  translation: { displayName: "Traductions" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "conditionRates",
        displayName: "Conditions",
      },
      {
        fieldName: "canModifyDates",
        displayName: "Modifier les dates",
      },
      {
        fieldName: "canModifyAccommodations",
        displayName: "Modifier l'hébergement",
      },
      {
        fieldName: "excludedStayDates",
        displayName: "Dates de Séjour Exclues",
      },
      {
        fieldName: "maxAllowedChanges",
        displayName: "Limite de Modifications",
      },
      {
        fieldName: "dates",
        displayName: "Dates de Modification",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "hotelTicker",
        displayName: "Code de l'hôtel",
        widget: "hidden",
      },
      {
        fieldName: "rateTypeSection",
        displayName: "Modifier les dates",
        widget: "section",
      },

      {
        fieldName: "canModifyDates",
        widget: "singleSwitch",
        displayName: "Activé",
      },
      {
        fieldName: "datesMinRelease",
        displayName: "Délai minimum pour les modifications (jours) :",
        widget: "input",
      },
      {
        fieldName: "excludedStayDatesSection",
        displayName: "Dates de séjour exclues",
        widget: "section",
        className: "noBorderNoMargin",
      },
      {
        fieldName: "excludedStayDates",
        introductionText: [],
        widget: "nestedEntity",
        nested: true,
        entityName: "modificationBookingWindow",
        nestedTitle: "Dates de séjour exclues",
        minHeight: 500,
        defaultValue: [],
      },
      {
        fieldName: "datesModificationRestrictionType",
        widget: "selector",
        displayName: "Seulement si :",
        className: "datesSelector",
        optionDisplay: {
          AMOUNT_AND_STAY_GTE: {
            label: "La durée du séjour est supérieure ou égale à la durée et au montant du séjour",
          },
          STAY_GTE: {
            label: "La durée du séjour est identique ou supérieure",
          },
          AMOUNT_GTE: {
            label: "Le montant du séjour est identique ou supérieur",
          },
          NO_RESTRICTION: {
            label: "Liberté totale pour changer les dates de séjour",
          },
        },
      },
      {
        fieldName: "accommodationSection",
        displayName: "Modifier les hébergements",
        widget: "section",
      },
      {
        fieldName: "canModifyAccommodations",
        widget: "singleSwitch",
        displayName: "Activé",
      },
      {
        fieldName: "accommodationMinRelease",
        displayName: "Délai minimum pour les modifications (jours) :",
        widget: "input",
      },
      {
        fieldName: "accommodationModificationRestrictionType",
        displayName: "Seulement si :",
        widget: "selector",
        optionDisplay: {
          AMOUNT_GTE: {
            label: "Le montant du séjour est identique ou supérieur",
          },
          NO_RESTRICTION: {
            label: "Liberté totale pour changer les dates de séjour",
          },
        },
      },
      {
        fieldName: "canChangeConditions",
        widget: "singleSwitch",
        displayName: "Changement de tarif :",
        helpText:
          "La réservation peut être modifiée pour une autre condition/tarif disponible (par ex. de CG à NR).",
      },
      {
        fieldName: "conditionSection",
        displayName: "S'applique aux conditions :",
        widget: "section",
      },
      {
        fieldName: "conditions",
        widget: "multicheckbox",
        visible: ({ formValues, entity }) => entity.ticker !== "DEFAULT",
      },
      {
        fieldName: "restrictionsSection",
        displayName: "Restrictions",
        widget: "section",
      },
      {
        fieldName: "maxAllowedChanges",
        displayName: "Nombre maximum de modifications",
        widget: "input",
      },
      {
        fieldName: "modificationAllowedFrom",
        displayName: "Dates de modification",
        placeholder: "Entrez une date",
      },
      {
        fieldName: "modificationAllowedUntil",
        placeholder: "Entrez une date",
      },
    ],
  },
};
